// from http://www.frontcoded.com/javascript-fit-rectange-into-bounds.html
export default function(rect, bounds) {
  var rectRatio = rect.width / rect.height;
  var boundsRatio = bounds.width / bounds.height;

  var newDimensions = {};

  // Rect is more landscape than bounds - fit to width
  if(rectRatio > boundsRatio) {
    newDimensions.width = bounds.width;
    newDimensions.height = rect.height * (bounds.width / rect.width);
  }
  // Rect is more portrait than bounds - fit to height
  else {
    newDimensions.width = rect.width * (bounds.height / rect.height);
    newDimensions.height = bounds.height;
  }

  return newDimensions;
};



// WEBPACK FOOTER //
// ./src/lib/fitRectIntoBounds.js